module.exports = __webpack_public_path__ + "static/media/Ashoka_Chakra.e86977fd.svg";